import { Dialog } from "@mui/material"
import { useContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import FormRecebimentoTitulos from "./FormRecebimentoTitulos/index";
import DialogAppBar from "../../../../../components/DialogAppBar";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { IDataListaTitulosReceber } from "../../../../../types/api/financeiro/pesquisar-titulos-receber";
import moment from "moment";
import useSetParamsURL from "../../../../../lib/useSetParamsURL";

export default function DialogRegistrarRecebimento({
    open,
    handleClose,
    valoresTitulos = []
}: DialogRegistrarRecebimentoProps) {

    const { userPerfilComLoja } = useContext(AuthContext);
    const { clearParamsUrl } = useSetParamsURL()
    const lojaUsuario = userPerfilComLoja?.loja


    //Funções manipuladoras
    const handleNextStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper + 1)
    }

    const handleBackStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper - 1)
    }
    //

    //valores importantes
    const titPreEnviados = valoresTitulos.length > 0

    const defaultValuesForm = {
        stepper: titPreEnviados ? 1 : 0,
        preFilterStep: true,
        selecionar_titulos: valoresTitulos,
        qtd_titulos: titPreEnviados ? valoresTitulos.length : 0,
        total_atualizado: 0,
        juros_atualizado: 0,
        dados_recebimento: {
            forma_recebimento: 'registrar recebimento',
        },
        finalizacao: {
            aplicarDiferencaComoDesconto: false,
            aplicarDiferencaSemCupom: false,
            aplicarDiferencaComCupom: false,
            cupomDesconto: '',
            aplicarDiferencaComoJuros: false,
            gravarCaixaBanco: "true",
            usuarioComLoja: Boolean(lojaUsuario),
            data_recebimento: moment(),
            loja: lojaUsuario ? { id: lojaUsuario.id, nome: lojaUsuario.nome } : null,
            recebimentos: [],
            compensacao: []
        },
        recebimentoRegistrado: null,
        funcoesAux: {
            proibidoSelectTitulos: titPreEnviados,
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose
        },
        total: titPreEnviados ? valoresTitulos.reduce((total, valor) => total + valor.saldo_principal, 0) : 0,
        titPreEnviados: titPreEnviados
    }

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue } = methods
    //

    useEffect(() => {
        if (!titPreEnviados) clearParamsUrl()
    }, [])

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                fullScreen
            >
                <DialogAppBar
                    {...{ handleClose }}
                    title="Registrar recebimento de títulos"
                />

                <FormRecebimentoTitulos />
            </Dialog>
        </FormProvider>
    )
}

interface DialogRegistrarRecebimentoProps {
    open: boolean;
    handleClose: () => void;
    valoresTitulos?: IDataListaTitulosReceber[]
}